import React from 'react';
import { Navigate } from 'react-router-dom';
import { OAuthPopup } from '@tasoskakour/react-use-oauth2';

//AuthenticationInner pages
import Basic403 from '../pages/AuthenticationInner/Errors/Basic403';
import Basic404 from '../pages/AuthenticationInner/Errors/Basic404';

//login
import Login from '../pages/Authentication/Login';
import ForgetPasswordPage from '../pages/Authentication/ForgetPassword';
import ResetPasswordPage from '../pages/Authentication/ResetPassword';
import Logout from '../pages/Authentication/Logout';
import Register from '../pages/Authentication/Register';

// User Profile
import UserProfile from '../pages/Authentication/user-profile';
import Users from '../pages/Admin/Users';

// Role Management
import Roles from '../pages/Admin/Roles';

// Masters
import Masters from '../pages/Admin/Masters';

// User Profile
import Establishments from '../pages/Establishment/Establishments';
import Holdings from '../pages/Establishment/Holdings';
import Companies from '../pages/Establishment/Companies';
import Managements from '../pages/Establishment/Managements';
import MaintenanceCompany from '../pages/Establishment/MaintenanceCompany';

//Calendar
import Normatives from '../pages/Normative/Normatives';
import Kanban from '../pages/Normative/Kanban';
import Obligations from '../pages/Normative/Obligations';
import FinalDestination from '../pages/Residue/FinalDestinations';
import ResidueCategory from '../pages/Residue/ResidueCategory';
import Residues from '../pages/Residue/Residues';
import GuideRegister from '../pages/Residue/Guides/GuideRegister';
import ResidueGuideRegisterRedirect from '../pages/Residue/legacy/ResidueGuideRegisterRedirect';
import Guides from '../pages/Residue/Guides';
import GuidesFlat from '../pages/Residue/GuidesFlat';
import GuideDetails from '../pages/Residue/GuideDetail';
import Transfers from '../pages/Transfer/Transfers';
import TransferCompanies from '../pages/Transfer/TransferCompanies';
import TransferDrivers from '../pages/Transfer/TransferDrivers';

//File Manager
import FileManager from '../pages/FileManager';
import DashboardEstablishment from '../pages/Establishment/Dashboard';

import DashboardResidue from '../pages/Residue/Dashboard';
import WarehouseReception from '../pages/Residue/WarehouseReception';
import RespelIntake from '../pages/Residue/Respel/Intake';
import RespelIntakeHub from '../pages/Residue/Respel/Intake/RespelIntakeHub';
import RespelStock from '../pages/Residue/Respel/Stock';
import RespelStockHub from '../pages/Residue/Respel/Stock/RespelStockHub';

import DashboardPrincipal from '../pages/Dashboard';
import HomePage from '../pages/Home';
import FinalDestinationReception from '../pages/Residue/FinalDestinationReception';
import FinalDestinationCertificationProcess from '../pages/Residue/FinalDestinationCertificationProcess';
import DashboardVariable from '../pages/Variable/Dashboard';
import Statement from '../pages/Residue/Statement';

import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsCondition from '../pages/TermsCondition';
import Faqs from '../pages/Faqs';
import Statements from '../pages/Residue/Statements';
import DashboardWarehouse from '../pages/Warehouse/Dashboard';
import WarehouseCategories from '../pages/Warehouse/Category';
import WarehouseItems from '../pages/Warehouse/Item';
import ProductiveCycles from '../pages/ProductiveCycle';
import DashboardControl from '../pages/Control';
import EstablishmentSummary from '../pages/Establishment/Establishments/Summary';
import EstablishmentActivities from '../pages/Establishment/Establishments/Summary/Activities';
import EstablishmentRecord from '../pages/Establishment/Establishments/Summary/Record';
import TaskDetails from '../pages/Establishment/Establishments/Forms/TaskDetails';
import FeedingBarges from '../pages/Establishment/FeedingBarges';

import Screen from '../pages/Screen/Screens';
import Field from '../pages/Screen/Fields';
import AddEditScreen from '../pages/Screen/Screens/Add_Edit/AddEditScreen';
import Modules from '../pages/Admin/Modules';
import ReportView from '../pages/Finance/ReportView';
import ReportBuilder from '../pages/Report/ReportBuilder';
import PageTypeList from '../pages/Report/BuildReport/PageTypeList';
import Pages from '../pages/Report/BuildReport/Page';
import Graph from '../pages/Report/BuildReport/Graph';
import ReportTemplate from '../pages/Report/BuildReport/ReportTemplate';
import Reports from '../pages/Finance/Report';
import PowerGenerationSource from '../pages/Establishment/PowerGenerationSource';
import PowerGenerationSourceSummary from '../pages/Establishment/PowerGenerationSource/PowerGenerationSourceSummary';
import PowerGenerationDailyConsumption from '../pages/Establishment/PowerGenerationSource/PowerGenerationDailyConsumption';
import FuelTank from '../pages/Establishment/FuelTank';
import FeedingSilo from '../pages/Establishment/FeedingSilo';
import FuelSupply from '../pages/Establishment/FuelSupply';
import FuelSupplySummary from '../pages/Establishment/FuelSupply/FuelSupplySummary';
import SupplyByCenter from '../pages/Establishment/FuelSupply/SupplyByCenter';
import PowerGenerationHourMeter from '../pages/Establishment/PowerGenerationHourMeter';
import CalendarMaintenance from '../pages/Operation/Maintenance/CalendarMaintenance';
// import MainCalendar from '../pages/Calendar/MainCalendar';
import PowerGenerationSourceEnvironment from '../pages/Establishment/PowerGenerationSource/indexEnvironment';
import MainCalendar from '../pages/CalendarNew/MainCalendar';

//Beach Cleaning
import BeachCleaningRegister from '../pages/BeachCleaning/BeachCleaningRegister';
import BeachCleanings from '../pages/BeachCleanings';

//Fiscalization
import Fiscalizaciones from '../pages/Fiscalizacion/Fiscalizaciones';
import Actividades from '../pages/Fiscalizacion/Actividades';
import FiscalizacionDashboard from '../pages/Fiscalizacion/Dashboard';

import PowerGenerationMaintenance from '../pages/Establishment/PowerGenerationMaintenance';
import Measurements from '../pages/Variable/Measurements';
import MeasurementsSMA from '../pages/Variable/Measurements SMA';
import Incidents from '../pages/Variable/Incidents';
import ProductiveCyclesStage from '../pages/ProductiveCycleStage';
import FuelSupplyPanel from '../pages/Establishment/FuelSupply/Dashboard';
import Payment from '../pages/Admin/Payment';
import ModuleUsageFacts from '../pages/Admin/ModuleUsageFacts';
import InformationRegisterSMA from '../pages/Variable/Register';
import PersonalProtectiveEquipment from '../pages/PersonalProtectiveEquipment';
import Warehouses from '../pages/Establishment/Warehouse';
import WarehouseGroups from '../pages/Warehouse/Group';
import Periods from '../pages/Supply/Periods';
import Persons from '../pages/Establishment/Person';
import FuelType from '../pages/Establishment/FuelType';
import FuelDashboard from '../pages/Establishment/Establishments/Summary/Dashboard/FuelDashboard';
import ManagementFuelDashboard from '../pages/Establishment/Establishments/Summary/Dashboard/ManagementFuelDashboard';
import PersonalProtectiveEquipmentDashboard from '../pages/PersonalProtectiveEquipment/PersonalProtectiveEquipmentDashboard';
import PersonalProtectiveEquipmentSupply from '../pages/PersonalProtectiveEquipment/PersonalProtectiveEquipment';
import PersonalProtectiveEquipmentMotion from '../pages/PersonalProtectiveEquipment/PersonalProtectiveEquipmentMotion';
import WaterRights from '../pages/Normative/WaterRights';
import ConsumptionSource from '../pages/Establishment/ConsumptionSource';
import PersonalProtectiveEquipmentDashboardCenter from '../pages/PersonalProtectiveEquipment/PersonalProtectiveEquipmentDashboardCenter';
import CostCenter from '../pages/Establishment/CostCenter';
import WarehousePPEItems from '../pages/Warehouse/PPE';
import TransferList from '../pages/Warehouse/PPE/Transfers';
import ItemsList from '../pages/Warehouse/PPE/Item';
import ResidueDashboard from '../pages/Residue/Dashboard/ResidueDashboard';
import DemoFuelDashboard from '../pages/Establishment/Establishments/Summary/Dashboard/DemoBlumar/DemoFuelDashboard';
import DashboardMonitoringFAN from '../pages/Monitoring FAN/Dashboard';
import DashboardVariableRILes from '../pages/RILes/Dashboard';
import DispatchGuideRegister from '../pages/Warehouse/Guide';
import ManagementPPEDashboard from '../pages/Establishment/Establishments/Summary/Dashboard/ManagementPPEDashboard';
import PositionList from '../pages/Warehouse/Position';
import GuidesList from '../pages/Warehouse/Guides/GuidesList';
// import DemoFuelDashboard from '../pages/Establishment/Establishments/Summary/Dashboard/DemoBlumar/DemoFuelDashboard';

//Wather Rights
import WatherRightRegister from '../pages/WatherRight/WatherRightRegister/index';
import WaterRigth from '../pages/WatherRight/index';
import WorkDetails from '../pages/WatherRight/WorkDetails';
import WaterRightsDashboard from '../pages/WatherRight/Dashboard';
import CultivationUnits from '../pages/WatherRight/Config/CultivationUnit';
import MeasurementFrequencies from '../pages/WatherRight/Config/MeasurementFrequency';
import WRPositions from '../pages/WatherRight/Config/WRPosition';
import ReportingFrequencies from '../pages/WatherRight/Config/ReportingFrequency';
import ReportingTypes from '../pages/WatherRight/Config/ReportingType';
import ProcedureTypes from '../pages/WatherRight/Config/ProcedureType';
import DocumentTypes from '../pages/WatherRight/Config/DocumentType';
import DistanceUnits from '../pages/WatherRight/Config/DistanceUnit';
import FlowRateUnits from '../pages/WatherRight/Config/FlowRateUnit';
import WaterSources from '../pages/WatherRight/Config/WaterSource';
import WaterSourceTypes from '../pages/WatherRight/Config/WaterSourceType';
import UtmZones from '../pages/WatherRight/Config/UtmZone';
import GeodeticDatums from '../pages/WatherRight/Config/GeodeticDatum';
import InstallationLocations from '../pages/WatherRight/Config/InstallationLocation';
import RealEstateRegistries from '../pages/WatherRight/Config/RealEstateRegistry';
import ReportingStatuses from '../pages/WatherRight/Config/ReportingStatus';
import RightExerciseTypes from '../pages/WatherRight/Config/RightExerciseType';
import WaterRightsStatuses from '../pages/WatherRight/Config/WaterRightsStatus';
import WaterRightTypes from '../pages/WatherRight/Config/WaterRightType';
import WaterUseStatus from '../pages/WatherRight/Config/WaterUseStatus';
import WaterUseTypes from '../pages/WatherRight/Config/WaterUseType';
import WorkStatus from '../pages/WatherRight/Config/WorkStatus';
import WorkOrderStatuses from '../pages/WatherRight/Config/WorkOrderStatus';
import MeasurementDetailsList from '../pages/WatherRight/MeasurementDetails';
import PersonalProtectiveEquipmentPersonAssignments from '../pages/PersonalProtectiveEquipment/PersonalProtectiveEquipmentPersonAssignments';

const authProtectedRoutes = [
	{ path: '/faqs', component: <Faqs /> },
	{ path: '/privacy-policy', component: <PrivacyPolicy /> },
	{ path: '/terms-condition', component: <TermsCondition /> },

	//* Establishment *//
	// Establishments
	{ path: '/establishments', component: <Establishments /> },
	{ path: '/warehouses', component: <Warehouses /> },
	{ path: '/persons', component: <Persons /> },
	{ path: '/establishment/holdings', component: <Holdings /> },
	{ path: '/companies', component: <Companies /> },
	{ path: '/company/cost-center', component: <CostCenter /> },
	{ path: '/company/departments', component: <Managements /> },
	{ path: '/establishment/dashboard', component: <DashboardEstablishment /> },
	{
		path: '/establishment/summary',
		component: <Navigate to='' replace />,
	}, // Redirige si falta `:id`
	{ path: '/establishment/summary/:id', component: <EstablishmentSummary /> },
	{
		path: '/establishment/summary/fuel/:id',
		component: <FuelDashboard />,
	},
	{
		path: '/establishment/management-summary/fuel',
		component: <ManagementFuelDashboard />,
	},
	{
		path: '/establishment/management-summary/ppe',
		component: <ManagementPPEDashboard />,
	},
	{
		path: '/establishment/activities',
		component: <Navigate to='/404' replace />,
	}, // Redirige si falta `:id`
	{
		path: '/establishment/activities/:id',
		component: <EstablishmentActivities />,
	},
	{ path: '/establishment/activity/:id', component: <TaskDetails /> },
	{ path: '/establishment/record', component: <Navigate to='/404' replace /> }, // Redirige si falta `:id`
	{ path: '/establishment/record/:id', component: <EstablishmentRecord /> },

	//* Warehouse *//
	{ path: '/warehouse/dashboard', component: <DashboardWarehouse /> },
	{ path: '/warehouse/category', component: <WarehouseCategories /> },
	{ path: '/warehouse/group', component: <WarehouseGroups /> },
	{ path: '/warehouse/items/:id', component: <WarehouseItems /> },
	{ path: '/warehouse/:id/ppe/items', component: <ItemsList /> },
	{ path: '/warehouse/:id/ppe/transfers', component: <TransferList /> },
	{ path: '/warehouse/guide/register', component: <DispatchGuideRegister /> },
	{ path: '/warehouse/guide', component: <DispatchGuideRegister /> },
	{ path: '/warehouse/guides', component: <GuidesList /> },
	{ path: '/warehouse/guides/:folio', component: <GuidesList /> },
	// Supply
	{ path: '/supply/periods', component: <Periods /> },
	{ path: '/supply/positions', component: <PositionList /> },

	//* Normative *//
	{ path: '/normative/list', component: <Normatives /> },
	{ path: '/normative/obligations', component: <Obligations /> },
	{ path: '/normative/kanban', component: <Kanban /> },
	{ path: '/water-rights/dashboard', component: <WaterRightsDashboard /> },
	{ path: '/water-rights/list', component: <WaterRights /> },
	{ path: '/water-rights/work/:id', component: <WorkDetails /> },
	{ path: '/water-right/measurements', component: <MeasurementDetailsList /> },
	{
		path: '/config/water-right/cultivation-unit',
		component: <CultivationUnits />,
	},
	{
		path: '/config/water-right/measurement-frequency',
		component: <MeasurementFrequencies />,
	},
	{ path: '/config/water-right/position', component: <WRPositions /> },
	{
		path: '/config/water-right/reporting-frequency',
		component: <ReportingFrequencies />,
	},
	{
		path: '/config/water-right/procedure-type',
		component: <ProcedureTypes />,
	},
	{ path: '/config/water-right/document-type', component: <DocumentTypes /> },
	{ path: '/config/water-right/distance-unit', component: <DistanceUnits /> },
	{ path: '/config/water-right/flow-rate-unit', component: <FlowRateUnits /> },
	{ path: '/config/water-right/water-source', component: <WaterSources /> },
	{
		path: '/config/water-right/water-source-type',
		component: <WaterSourceTypes />,
	},
	{ path: '/config/water-right/utm-zone', component: <UtmZones /> },
	{
		path: '/config/water-right/geodetic-datum',
		component: <GeodeticDatums />,
	},
	{
		path: '/config/water-right/installation-location',
		component: <InstallationLocations />,
	},
	{
		path: '/config/water-right/real-estate-registry',
		component: <RealEstateRegistries />,
	},
	{
		path: '/config/water-right/reporting-status',
		component: <ReportingStatuses />,
	},
	{
		path: '/config/water-right/right-exercise-type',
		component: <RightExerciseTypes />,
	},
	{
		path: '/config/water-right/water-rights-status',
		component: <WaterRightsStatuses />,
	},
	{ path: '/config/water-right/type', component: <WaterRightTypes /> },
	{ path: '/config/water-right/use-status', component: <WaterUseStatus /> },
	{ path: '/config/water-right/water-use-type', component: <WaterUseTypes /> },
	{ path: '/config/water-right/activity-status', component: <WorkStatus /> },
	{
		path: '/config/water-right/work-order-status',
		component: <WorkOrderStatuses />,
	},
	{
		path: '/config/water-right/reporting-type',
		component: <ReportingTypes />,
	},

	//* Production *//
	{ path: '/production/productive-cycle', component: <ProductiveCycles /> },
	{
		path: '/production/productive-cycle-stage',
		component: <ProductiveCyclesStage />,
	},

	//* Operation *//
	{ path: '/operation/feeding-barges', component: <FeedingBarges /> },
	{ path: '/operation/consumption-source', component: <ConsumptionSource /> },
	{
		path: '/operation/power-generation-source',
		component: <PowerGenerationSource />,
	},
	{
		path: '/operation/power-generation-source/summary',
		component: <PowerGenerationSourceSummary />,
	},
	{
		path: '/environment/emissions/reports/consumos-por-fuente',
		component: <PowerGenerationSourceSummary />,
	},
	{
		path: '/environment/emissions/reports/daily-consumption-by-generation',
		component: <PowerGenerationDailyConsumption />,
	},
	{
		path: '/environment/power-generation-source',
		component: <PowerGenerationSourceEnvironment />,
	},

	{
		path: '/operation/calendar/maintenance',
		component: <CalendarMaintenance />,
	},
	{
		path: '/operation/activity/maintenance',
		component: <PowerGenerationMaintenance />,
	},

	{
		path: '/operation/maintenance-company',
		component: <MaintenanceCompany />,
	},

	{ path: '/supply/fuel-tank', component: <FuelTank /> },
	{ path: '/supply/fuel-type', component: <FuelType /> },
	{ path: '/operation/feeding-silo', component: <FeedingSilo /> },
	{
		path: '/operation/fuel-supply',
		component: <Navigate to='/404' replace />,
	}, // Redirige si falta `:id`
	{ path: '/supply/fuel-supply/:id', component: <FuelSupply /> },
	{ path: '/supply/fuel/summary', component: <FuelSupplySummary /> },
	{
		path: '/environment/emissions/reports/supply-by-establishment',
		component: <SupplyByCenter />,
	},
	{ path: '/supply/fuel/dashboard', component: <FuelSupplyPanel /> },

	{ path: '/supply/ppe/list', component: <PersonalProtectiveEquipment /> },
	{ path: '/supply/ppe', component: <PersonalProtectiveEquipmentSupply /> },
	{ path: '/supply/ppe/person-assignments', component: <PersonalProtectiveEquipmentPersonAssignments /> },
	{
		path: '/supply/ppe/motion',
		component: <PersonalProtectiveEquipmentMotion />,
	},
	{
		path: '/supply/ppe/summary',
		component: <PersonalProtectiveEquipmentDashboard />,
	},
	{
		path: '/supply/ppe/summary/center/:id',
		component: <PersonalProtectiveEquipmentDashboardCenter />,
	},

	{ path: '/operation/hour-meter', component: <Navigate to='/404' replace /> }, // Redirige si falta `:id`
	{
		path: '/operation/hour-meter/:id',
		component: <PowerGenerationHourMeter />,
	},

	//* Residue *//
	// Final Destinations
	{ path: '/residue/final-destinations', component: <FinalDestination /> },
	// Residue Categorys
	{ path: '/residue/residue-categorys', component: <ResidueCategory /> },
	// Residues
	{ path: '/residue/residues', component: <Residues /> },
	// Guides
	{ path: '/residue/guides', component: <Guides /> },
	// Legacy register — redirect al generador unificado (código legacy en GuideRegister/)
	{
		path: '/residue/guides/register',
		component: <ResidueGuideRegisterRedirect />,
	},
	// Guides Register (Edit)
	{ path: '/residue/guides/:idGuide/', component: <GuideRegister /> },
	// Guides
	{ path: '/residue/guide-details', component: <GuideDetails /> },
	// Guides Flat (solo peligrosos / no peligrosos). Ruta “todas” sin :scope retirada — descomentar si se reactiva:
	// { path: '/residue/guides-flat', component: <GuidesFlat /> },
	{ path: '/residue/guides-flat/:scope', component: <GuidesFlat /> },
	// Dashboard
	{ path: '/residue/dashboard', component: <ResidueDashboard /> },
	{ path: '/residue/respel/movements', component: <RespelIntakeHub /> },
	{
		path: '/residue/respel/movements/:establishmentId',
		component: <RespelIntake />,
	},
	{ path: '/residue/respel/stock', component: <RespelStockHub /> },
	{
		path: '/residue/respel/stock/:establishmentId',
		component: <RespelStock />,
	},
	// Reception residues
	{ path: 'residue/warehouse/reception', component: <WarehouseReception /> },
	// Reception final destination guides
	{
		path: 'residue/final_destination/reception',
		component: <FinalDestinationReception />,
	},
	{
		path: 'residue/final_destination/certification-process',
		component: <FinalDestinationCertificationProcess />,
	},
	// Statement
	{ path: 'residue/statement', component: <Statements /> },
	{ path: 'residue/statement/new', component: <Statement /> },

	//* Transfer *//
	// Transfers
	{ path: '/logistic/transport', component: <Transfers /> },
	// Transfer Companies
	{ path: '/logistic/companies', component: <TransferCompanies /> },
	// Transfer Drivers
	{ path: '/logistic/drivers', component: <TransferDrivers /> },

	//User Profile
	{ path: '/profile', component: <UserProfile /> },
	{ path: '/admin/users', component: <Users />, allowedRoles: ['ADM'] },
	{ path: '/admin/modules', component: <Modules />, allowedRoles: ['ADM'] },
	{ path: '/admin/masters', component: <Masters />, allowedRoles: ['ADM'] },
	{ path: '/admin/payment', component: <Payment />, allowedRoles: ['ADM'] },
	{
		path: '/admin/module-usage-facts',
		component: <ModuleUsageFacts />,
		allowedRoles: ['ADM'],
	},

	//Role Management
	{
		path: '/admin/roles',
		component: <Roles />,
		onlySuperAdmin: true,
	},

	// this route should be at the end of all other routes
	// eslint-disable-next-line react/display-name
	{ path: '/', component: <HomePage /> },
	{ path: '*', component: <Navigate to="/" replace /> },

	//Calendar
	{ path: '/calendar', component: <MainCalendar /> },
	//File Manager
	{ path: '/file-manager', component: <FileManager /> },

	//Finance
	{ path: '/finance/report-view/:id', component: <ReportView /> },
	{ path: '/finance/build-report', component: <ReportBuilder /> },
	{ path: '/finance/page-types', component: <PageTypeList /> },
	{ path: '/finance/pages', component: <Pages /> },
	{ path: '/finance/graph', component: <Graph /> },
	{ path: '/finance/report-template', component: <ReportTemplate /> },
	{ path: '/finance/reports', component: <Reports /> },

	//Screens
	{
		path: '/screen/list',
		component: <Screen />,
	},
	{
		path: '/screen/fields',
		component: <Field />,
	},
	{
		path: '/screens/add',
		component: <AddEditScreen />,
	},

	//Dashboard Variable
	{ path: '/environment/variable', component: <DashboardVariable /> },
	{ path: '/environment/variable/measurements', component: <Measurements /> },
	{
		path: '/environment/variable/measurements-sma',
		component: <MeasurementsSMA />,
	},
	{
		path: '/environment/variable/register',
		component: <InformationRegisterSMA />,
	},
	{ path: '/environment/variable/incidents', component: <Incidents /> },

	//Monitoring FAN
	{ path: '/monitoring-fan/dashboard', component: <DashboardMonitoringFAN /> },

	//RILes
	{ path: '/RILes/dashboard', component: <DashboardVariableRILes /> },

	// //Dashboard Control
	// { path: '/control', component: <DashboardControl /> },

	// Beach Cleaning Register
	{
		path: '/residue/beach-cleanings/register',
		component: <BeachCleaningRegister />,
	},
	// Beach Cleaning Register (Edit)
	{
		path: '/residue/beach-cleanings/:idBeachCleaning',
		component: <BeachCleaningRegister />,
	},
	{ path: '/residue/beach-cleanings', component: <BeachCleanings /> },

	// Fiscalization
	{ path: '/fiscalizacion/dashboard', component: <FiscalizacionDashboard /> },
	{ path: '/fiscalizacion/fiscalizaciones', component: <Fiscalizaciones /> },
	{
		path: '/fiscalizacion/actividades/:inspectionId',
		component: <Actividades />,
	},

	{ path: '/404', component: <Basic404 /> },
	// Water Rights Register
	{
		path: '/water-right/register/:id?',
		component: <WatherRightRegister />,
	},
	{
		path: '/water-right/list',
		component: <WaterRigth />,
	},
];

const publicRoutes = [
	// Authentication Page
	{ path: '/logout', component: <Logout /> },
	{ path: '/login', component: <Login /> },
	{ path: '/oauth2-redirect', component: <OAuthPopup /> },
	{ path: '/forgot-password', component: <ForgetPasswordPage /> },
	{
		path: 'reset-password',
		component: <ResetPasswordPage />,
	},
	{ path: '/register', component: <Register /> },
	{ path: '/403', component: <Basic403 /> },

	// //AuthenticationInner pages
	// { path: '/auth-signin-basic', component: <BasicSignIn /> },
	// { path: '/auth-signin-cover', component: <CoverSignIn /> },
	// { path: '/auth-signup-basic', component: <BasicSignUp /> },
	// { path: '/auth-signup-cover', component: <CoverSignUp /> },
	// { path: '/auth-pass-reset-basic', component: <BasicPasswReset /> },
	// { path: '/auth-pass-reset-cover', component: <CoverPasswReset /> },
	// { path: '/auth-lockscreen-basic', component: <BasicLockScreen /> },
	// { path: '/auth-lockscreen-cover', component: <CoverLockScreen /> },
	// { path: '/auth-logout-basic', component: <BasicLogout /> },
	// { path: '/auth-logout-cover', component: <CoverLogout /> },
	// { path: '/auth-success-msg-basic', component: <BasicSuccessMsg /> },
	// { path: '/auth-success-msg-cover', component: <CoverSuccessMsg /> },
	// { path: '/auth-twostep-basic', component: <BasicTwosVerify /> },
	// { path: '/auth-twostep-cover', component: <CoverTwosVerify /> },
	// { path: '/auth-404-basic', component: <Basic404 /> },
	// { path: '/auth-404-cover', component: <Cover404 /> },
	// { path: '/auth-404-alt', component: <Alt404 /> },
	// { path: '/auth-500', component: <Error500 /> },

	// { path: '/auth-pass-change-basic', component: <BasicPasswCreate /> },
	// { path: '/auth-pass-change-cover', component: <CoverPasswCreate /> },
	// { path: '/auth-offline', component: <Offlinepage /> },
];

export { authProtectedRoutes, publicRoutes };
